import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ellipsis",
  "use": "ellipsis-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"ellipsis\">\n  <g fill-rule=\"evenodd\">\n    <rect fill=\"transparent\" width=\"20\" height=\"20\" />\n    <path d=\"M9,4 L11,4 L11,6 L9,6 L9,4 Z M9,9 L11,9 L11,11 L9,11 L9,9 Z M9,14 L11,14 L11,16 L9,16 L9,14 Z\" transform=\"rotate(90 10 10)\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol